import * as Banner from './banner';
import * as Form from '../forms/form';
import * as Inline from './inline';
import * as Launcher from './launcher';
import * as Modal from './modal';

export function widget_id(config) {
  return config.widget.id
}

export function get(config) {
  return document.querySelector(`#widget-${config.widget.id}`);
}

export function show(config) {
  switch (config.widget.format_config.type) {
  case "banner":
    Banner.show(config)
    break;
  case "inline":
    Inline.show(config)
    break;
  case "launcher":
    Launcher.show(config)
    break;
  case "modal":
    Modal.show(config)
    break;
  default:
    console.log(`Format type ${config.widget.format_config.type} not supported yet`)
  }
}

export function hide(config) {
  switch (config.widget.format_config.type) {
  case "banner":
    Banner.hide(config)
    break;
  case "inline":
    Inline.hide(config)
    break;
  case "launcher":
    Launcher.hide(config)
    break;
  case "modal":
    Modal.hide(config)
    break;
  default:
    console.log(`Format type ${config.widget.format_config.type} not supported yet`)
  }
}

export function toggle(config) {
  if (is_visible(config)) {
    hide(config);
  } else {
    show(config);
  }
}

export function is_visible(config) {
  var widget = get(config);

  return widget && !widget.classList.contains('invisible')
}

export function init_content(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising widget content: ${config.widget.id}`);
  }

  if (config.widget.format_config.display_tech == 'js') {
    switch (config.widget.type) {
      case 'form':
        Form.init(config);
        break;

      case 'chat':
        console.warn('Chat not supported yet');
        break;
    }
  }
}
